<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <form class="form" [formGroup]="model" (ngSubmit)="exportar()">
      <div class="row">
        <div class="col-12">
          <h1 class="title-default">Relatório de Vendas com Promoções Aplicadas</h1>
        </div>
      </div>

      <div class="row">
        <div class="col-md-11">
          <div class="row">
            <div class="col-md-4">
              <h6 class="subtitle">Período de vendas</h6>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>De</mat-label>
                <input
                  matInput
                  [matDatepicker]="dataInicioPicker"
                  formControlName="dataInicio"
                  placeholder="DD/MM/AAAA" />
                <mat-datepicker-toggle matIconSuffix [for]="dataInicioPicker"></mat-datepicker-toggle>
                <mat-datepicker #dataInicioPicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-md-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Até</mat-label>
                <input
                  matInput
                  [matDatepicker]="dataFimPicker"
                  formControlName="dataFim"
                  placeholder="DD/MM/AAAA" />
                <mat-datepicker-toggle matIconSuffix [for]="dataFimPicker"></mat-datepicker-toggle>
                <mat-datepicker #dataFimPicker></mat-datepicker>
                @if (model.get('dataFim')?.errors?.['dataInvalida']) {
                  <mat-error>A data final deve ser maior que a data inicial</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-md-1"></div>
            <div class="col-md-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>NFC-e</mat-label>
                <input matInput type="number" formControlName="nfce" />
              </mat-form-field>
            </div>
            <div class="col-md-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Série</mat-label>
                <input matInput type="number" formControlName="serie" />
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-md-9">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Promoção</mat-label>
                <input
                  type="text"
                  placeholder="Selecione uma promoção"
                  aria-label="Promoção"
                  matInput
                  formControlName="promocao"
                  [matAutocomplete]="autoPromocao" />
                <mat-autocomplete #autoPromocao="matAutocomplete" [displayWith]="displayPromocao">
                  @for (tipo of listaTiposPromocao; track tipo) {
                    <mat-option [value]="tipo"> {{ tipo.nome }} - {{ tipo.descricao }} </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-md-9">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Produto</mat-label>
                <input
                  type="text"
                  placeholder="Digite o código de barras ou a descrição do produto"
                  aria-label="Produto"
                  matInput
                  formControlName="produto"
                  [matAutocomplete]="autoProduto" />
                <mat-autocomplete #autoProduto="matAutocomplete" [displayWith]="displayProduto">
                  @if (_isLoadingProduto && ((produtosFiltrados | async)?.length ?? 0) < 1) {
                    <mat-option disabled>
                      <mat-spinner diameter="20"></mat-spinner>
                    </mat-option>
                  } @else if (
                    !_isLoadingProduto &&
                    ((produtosFiltrados | async)?.length ?? 0) < 1 &&
                    model.get('produto')?.value !== '' && model.get('produto')?.value.length > 2
                  ) {
                    <mat-option disabled>
                      <small>Nenhum produto encontrado</small>
                    </mat-option>
                  }
                  @for (produto of produtosFiltrados | async; track produto) {
                    <mat-option [value]="produto">
                      @if (!_isLoadingProduto) {
                        <small>{{ produto.codigoBarras }} </small>
                        <small> - {{ produto.nomeProduto }}</small>
                      } @else {
                        <mat-option disabled>
                          <mat-spinner diameter="20"></mat-spinner>
                        </mat-option>
                      }
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-4 d-flex gap-3">
          <button
            type="submit"
            mat-flat-button
            class="btn-primary button-big button-responsivo"
            [disabled]="buttonDesativado">
            @if (!_isLoading) {
              Exportar
            } @else {
              <mat-spinner diameter="20"></mat-spinner>
            }
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
